/* Nexlane — conversion helpers
 *
 * 1. Cart savings progress bar
 * 2. Product-page volume-discount prompt
 *
 * Both mirror the two automatic volume discounts:
 *   2 items  -> 10% off
 *   3+ items -> 15% off
 * The bar reads the real cart via /cart.js so the message can never drift
 * from what Shopify actually applies at checkout.
 */
(function () {
  'use strict';

  var EL_ID = 'nx-savings-bar';
  var PDP_ID = 'nx-volume-note';
  var inflight = false;
  var queued = false;

  /* ---------------------------------------------------------------- cart bar */

  function stateFor(count) {
    if (count <= 0) return null;
    if (count === 1) {
      return {
        fill: 34,
        cls: 'nx-sb--go',
        html: 'Add <strong>1 more item</strong> and save <strong>10%</strong>'
      };
    }
    if (count === 2) {
      return {
        fill: 67,
        cls: 'nx-sb--go',
        html: 'Saving <strong>10%</strong> — add <strong>1 more</strong> for <strong>15%</strong>'
      };
    }
    return {
      fill: 100,
      cls: 'nx-sb--done',
      html: 'You’re saving <strong>15%</strong> on this order'
    };
  }

  function build(state) {
    var el = document.createElement('div');
    el.id = EL_ID;
    el.className = 'nx-sb ' + state.cls;
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');

    var msg = document.createElement('p');
    msg.className = 'nx-sb__msg';
    msg.innerHTML = state.html;

    var track = document.createElement('div');
    track.className = 'nx-sb__track';

    var fill = document.createElement('div');
    fill.className = 'nx-sb__fill';
    fill.style.width = state.fill + '%';

    track.appendChild(fill);
    el.appendChild(msg);
    el.appendChild(track);
    return el;
  }

  function hosts() {
    var found = [];
    var drawers = document.querySelectorAll('.cart-drawer__content');
    for (var i = 0; i < drawers.length; i++) found.push(drawers[i]);
    if (!found.length) {
      var page = document.querySelector('.cart-items-component');
      if (page) found.push(page);
    }
    return found;
  }

  function paint(count) {
    var state = stateFor(count);
    var targets = hosts();
    for (var i = 0; i < targets.length; i++) {
      var host = targets[i];
      var existing = host.querySelector('#' + EL_ID);
      if (!state) {
        if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
        continue;
      }
      var node = build(state);
      if (existing && existing.parentNode) {
        existing.parentNode.replaceChild(node, existing);
      } else {
        host.insertBefore(node, host.firstChild);
      }
    }
  }

  function cartUrl() {
    try {
      if (window.Theme && Theme.routes && Theme.routes.cart_url) {
        return Theme.routes.cart_url + '.js';
      }
    } catch (e) { /* fall through */ }
    return '/cart.js';
  }

  function refresh() {
    if (inflight) { queued = true; return; }
    inflight = true;
    fetch(cartUrl(), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        inflight = false;
        if (cart && typeof cart.item_count === 'number') paint(cart.item_count);
        if (queued) { queued = false; refresh(); }
      })
      .catch(function () {
        inflight = false;
        if (queued) { queued = false; refresh(); }
      });
  }

  var debounce;
  function scheduleRefresh() {
    clearTimeout(debounce);
    debounce = setTimeout(refresh, 220);
  }

  function watch() {
    if (!window.MutationObserver) return;
    var observer = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var target = records[i].target;
        if (target && target.closest && target.closest('#' + EL_ID)) continue;
        if (target && target.closest &&
            (target.closest('cart-drawer-component') || target.closest('.cart-items-component'))) {
          scheduleRefresh();
          return;
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  /* --------------------------------------------------- product-page prompt */

  function mountVolumeNote() {
    if (document.getElementById(PDP_ID)) return;

    var isProduct = false;
    try {
      isProduct = !!(window.Theme && Theme.template && Theme.template.name === 'product');
    } catch (e) { /* fall through */ }
    if (!isProduct) isProduct = /^\/products\//.test(window.location.pathname);
    if (!isProduct) return;

    // Sit directly under the buy buttons, where the decision is being made.
    var anchor = document.querySelector('.product-details .buy-buttons-block')
      || document.querySelector('.buy-buttons-block')
      || document.querySelector('product-form-component')
      || document.querySelector('.shopify-product-form');
    if (!anchor || !anchor.parentNode) return;

    var note = document.createElement('p');
    note.id = PDP_ID;
    note.className = 'nx-vol';
    note.innerHTML =
      '<span class="nx-vol__dot" aria-hidden="true"></span>' +
      'Buy <strong>2 save 10%</strong> · Buy <strong>3 save 15%</strong>' +
      '<span class="nx-vol__sub">Applied automatically — no code needed</span>';

    anchor.parentNode.insertBefore(note, anchor.nextSibling);
  }

  /* ------------------------------------------------------------------ boot */

  function start() {
    refresh();
    watch();
    mountVolumeNote();

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('[type="submit"], .quick-add__button, .add-to-cart-button, cart-drawer-component')) {
        scheduleRefresh();
      }
    }, true);

    document.addEventListener('cart:update', scheduleRefresh);
    document.addEventListener('cart:refresh', scheduleRefresh);

    // Horizon uses view transitions for navigation; re-mount on arrival.
    window.addEventListener('pageshow', function () {
      scheduleRefresh();
      mountVolumeNote();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
